export const campaignCopy = {
  inventoryTitle: { id: 'Email di sistem', ar: 'البريد في النظام' },
  inventoryHint: {
    id: 'Alamat unik, bukan jumlah pendaftaran. Kelayakan berdasarkan data aplikasi; blacklist provider yang belum dilaporkan mungkin belum tercatat.',
    ar: 'عناوين فريدة وليست عدد التسجيلات. الأهلية وفق بيانات التطبيق؛ قد لا يظهر حظر المزود غير المسجل بعد.',
  },
  uniqueEmails: { id: 'Email unik', ar: 'عناوين فريدة' },
  accounts: { id: 'Akun', ar: 'الحسابات' },
  duplicates: { id: 'Duplikat alamat digabung', ar: 'عناوين مكررة موحدة' },
  updatedAt: { id: 'Diperiksa', ar: 'آخر فحص' },
  refreshOverview: { id: 'Perbarui ringkasan', ar: 'تحديث الملخص' },
  overviewError: {
    id: 'Ringkasan belum dapat dimuat. Coba perbarui; angka tidak diasumsikan nol.',
    ar: 'تعذر تحميل الملخص. أعد التحديث؛ لا تُفترض الأعداد صفرًا.',
  },
  addressBook: { id: 'Periksa direktori email', ar: 'فحص دليل البريد' },
  directoryHint: {
    id: 'Direktori hanya untuk pemeriksaan, tidak mengirim email. Pilih program dan status untuk mencocokkan calon penerima kampanye. Jumlah final diperiksa ulang saat penjadwalan.',
    ar: 'الدليل للفحص فقط ولا يرسل بريدًا. اختر البرنامج وحالة التسجيل لمطابقة مستلمي الحملة. يُعاد فحص العدد عند الجدولة.',
  },
  allPrograms: { id: 'Semua program / akun', ar: 'كل البرامج / الحسابات' },
  directoryCount: { id: 'Alamat sesuai filter', ar: 'عناوين مطابقة للفلتر' },
  directoryError: {
    id: 'Direktori belum dapat dimuat. Coba lagi.',
    ar: 'تعذر تحميل الدليل. أعد المحاولة.',
  },
  awaitingReview: { id: 'Perlu dicocokkan dengan log', ar: 'تحتاج مطابقة السجل' },
  todayHint: {
    id: 'Status terkini penerima yang dicoba kirim hari ini, bukan jumlah email masuk inbox. Buka kampanye untuk tabel penerima dan progres lengkap.',
    ar: 'الحالة الحالية للمستلمين الذين جُرّب الإرسال إليهم اليوم وليست عدد الرسائل في الوارد. افتح الحملة لسجل المستلمين والتقدم الكامل.',
  },
  serviceTitle: { id: 'Koneksi & kesiapan Mailketing', ar: 'اتصال Mailketing وجاهزية الإرسال' },
  apiConnected: { id: 'API terhubung', ar: 'API متصل' },
  apiDisconnected: { id: 'API belum terhubung', ar: 'API غير متصل' },
  mailLoading: { id: 'Memeriksa layanan Mailketing…', ar: 'فحص خدمة Mailketing…' },
  mailError: {
    id: 'Pemeriksaan layanan belum dapat dimuat. Periksa lagi; status koneksi belum diketahui.',
    ar: 'تعذر تحميل فحص الخدمة. أعد الفحص؛ حالة الاتصال غير معروفة.',
  },
  senderLabel: { id: 'Alamat pengirim', ar: 'عنوان المرسل' },
  endpoint: { id: 'Endpoint API', ar: 'عنوان API' },
  authentication: { id: 'Autentikasi', ar: 'المصادقة' },
  tokenHidden: { id: 'X-Api-Token (tidak ditampilkan)', ar: 'X-Api-Token (غير معروض)' },
  senderCheck: { id: 'Daftar sender API', ar: 'قائمة مرسلي API' },
  senderListed: { id: 'Alamat tercantum', ar: 'العنوان مدرج' },
  senderNotListed: { id: 'Alamat tidak tercantum', ar: 'العنوان غير مدرج' },
  unknown: { id: 'Belum diketahui', ar: 'غير معروف' },
  credits: { id: 'Sisa kredit', ar: 'الرصيد المتبقي' },
  creditCost: {
    id: 'Kredit bukan jumlah email: biaya per kirim mengikuti aturan Mailketing.',
    ar: 'الرصيد ليس عدد الرسائل؛ تكلفة الإرسال وفق قواعد Mailketing.',
  },
  ready: { id: 'Sender tercantum & kredit tersedia', ar: 'المرسل مدرج والرصيد متاح' },
  reviewReadiness: { id: 'Kesiapan kirim perlu diperiksa', ar: 'يجب فحص جاهزية الإرسال' },
  senderHelp: {
    id: 'Tidak tercantum bukan berarti domain belum Verified. Cocokkan Add Domain / Sender dengan akun pemilik token API. Jika domain sudah Verified, konfirmasikan alamat pengirim pada akun yang sama dan gunakan uji kirim manual di Pengaturan.',
    ar: 'عدم إدراج العنوان لا يعني أن النطاق غير موثّق. طابق النطاق والمرسل مع حساب رمز API. إذا كان النطاق موثّقًا، أكد عنوان المرسل في الحساب نفسه واستخدم اختبار الإرسال اليدوي في الإعدادات.',
  },
  creditHelp: {
    id: 'Kredit kosong atau belum diketahui. Periksa saldo di dashboard Mailketing sebelum mengirim.',
    ar: 'الرصيد فارغ أو غير معروف. افحص رصيد لوحة Mailketing قبل الإرسال.',
  },
  mailScope: {
    id: 'Pemeriksaan ini hanya membaca API; tidak mengirim email dan tidak membuktikan pengantaran ke inbox. Penolakan domain, blacklist, dan bounce tetap ditangani saat pengiriman.',
    ar: 'هذا الفحص يقرأ API فقط ولا يرسل بريدًا أو يثبت وصوله إلى الوارد. يبقى رفض النطاق والحظر والارتداد خاضعًا للتحقق أثناء الإرسال.',
  },
  mailSettings: { id: 'Pengaturan & uji kirim manual', ar: 'الإعدادات واختبار الإرسال اليدوي' },
  mailDocs: { id: 'Panduan Mailketing', ar: 'دليل Mailketing' },
  title: { id: 'Kampanye Email', ar: 'حملات البريد' },
  description: {
    id: 'Susun informasi pembelajaran, kirim sekali sesuai jadwal WIB, dan pantau hasil tiap penerima.',
    ar: 'إعداد معلومات التعلم وإرسالها مرة واحدة في الموعد المحدد ومتابعة كل مستلم.',
  },
  create: { id: 'Buat kampanye', ar: 'إنشاء حملة' },
  back: { id: 'Daftar kampanye', ar: 'قائمة الحملات' },
  empty: {
    id: 'Belum ada kampanye. Buat draft pertama; tidak ada email dikirim saat menyimpan draft.',
    ar: 'لا توجد حملات. أنشئ المسودة الأولى؛ لا يُرسل بريد عند حفظ المسودة.',
  },
  disabled: {
    id: 'Pengiriman belum aktif. Draft, template, dan pratinjau tetap dapat digunakan. Pengelola sistem perlu melengkapi konfigurasi sebelum menjadwalkan.',
    ar: 'الإرسال غير مفعّل. يمكن حفظ المسودات والقوالب والمعاينة. يجب إكمال إعداد الخدمة قبل الجدولة.',
  },
  notice: {
    id: 'Diterima provider ≠ masuk inbox. Status gagal/blacklist diperbarui dari respons atau webhook Mailketing. Jika webhook belum aktif, cocokkan dengan log provider melalui rekonsiliasi.',
    ar: 'قبول المزود لا يعني الوصول إلى صندوق الوارد. تُحدّث حالة الفشل والحظر من الاستجابة أو إشعار Mailketing. دون إشعارات، طابق سجل المزود بالمصالحة.',
  },
  webhookMissing: {
    id: 'Webhook belum dikonfigurasi; pembaruan bounce/buka email belum otomatis.',
    ar: 'الإشعارات غير معدّة؛ تحديث الارتداد والفتح ليس تلقائيًا.',
  },
  loading: { id: 'Memuat kampanye…', ar: 'تحميل الحملات…' },
  retry: { id: 'Coba lagi', ar: 'إعادة المحاولة' },
  error: { id: 'Kampanye belum dapat dimuat. Coba lagi.', ar: 'تعذر تحميل الحملة. أعد المحاولة.' },
  denied: {
    id: 'Kampanye email hanya tersedia untuk administrator.',
    ar: 'حملات البريد متاحة للمسؤولين فقط.',
  },
  name: { id: 'Nama kampanye / template', ar: 'اسم الحملة / القالب' },
  subject: { id: 'Judul email', ar: 'عنوان البريد' },
  body: { id: 'Isi pesan', ar: 'نص الرسالة' },
  variables: {
    id: 'Variabel: {{nama}}, {{nip}}, {{program}}. Teks biasa; HTML tidak dieksekusi.',
    ar: 'المتغيرات: {{nama}}, {{nip}}, {{program}}. نص عادي؛ لا يُنفّذ HTML.',
  },
  actionLabel: { id: 'Label tombol (opsional)', ar: 'عنوان الزر (اختياري)' },
  actionUrl: { id: 'Tautan HTTPS tombol (opsional)', ar: 'رابط HTTPS للزر (اختياري)' },
  chooseAudience: { id: 'Penerima kampanye', ar: 'مستلمو الحملة' },
  programSearch: { id: 'Cari nama / kode program', ar: 'ابحث باسم / رمز البرنامج' },
  program: { id: 'Program', ar: 'البرنامج' },
  programPlaceholder: { id: 'Pilih program', ar: 'اختر البرنامج' },
  gender: { id: 'Gender', ar: 'الجنس' },
  allGender: { id: 'Ikhwan dan akhwat', ar: 'الرجال والنساء' },
  male: { id: 'Ikhwan', ar: 'الرجال' },
  female: { id: 'Akhwat', ar: 'النساء' },
  registrationStatus: { id: 'Status pendaftaran', ar: 'حالة التسجيل' },
  checkAudience: { id: 'Periksa penerima', ar: 'فحص المستلمين' },
  eligible: { id: 'Layak kirim', ar: 'صالح للإرسال' },
  excluded: { id: 'Dilewati', ar: 'متجاوز' },
  sample: {
    id: 'Contoh 20 penerima pertama; email dinormalisasi dan dideduplikasi.',
    ar: 'أول ٢٠ مستلمًا؛ تُوحّد عناوين البريد وتُزال التكرارات.',
  },
  consentHint: {
    id: 'Hanya akun aktif, email valid, dan persetujuan penggunaan data pembelajaran tercatat yang dikirim. Akun lama tanpa persetujuan ditampilkan sebagai dilewati.',
    ar: 'يُرسل فقط للحسابات النشطة بعناوين صالحة وموافقة مسجلة لاستخدام بيانات التعلم. تُتجاوز الحسابات القديمة دون موافقة.',
  },
  message: { id: 'Pesan & template', ar: 'الرسالة والقالب' },
  template: { id: 'Gunakan template', ar: 'استخدام قالب' },
  custom: { id: 'Pesan sendiri', ar: 'رسالة مخصصة' },
  announcement: { id: 'Informasi pembelajaran', ar: 'معلومات التعلم' },
  reminder: { id: 'Pengingat belajar', ar: 'تذكير بالتعلم' },
  announcementSubject: { id: 'Informasi {{program}}', ar: 'معلومات {{program}}' },
  announcementBody: {
    id: 'Assalamu’alaikum {{nama}},\n\nBerikut informasi pembelajaran untuk {{program}}.\n\n[Tulis informasi lengkap di sini]\n\nNIP: {{nip}}\nBID Support',
    ar: 'السلام عليكم {{nama}}،\n\nمعلومات التعلم لبرنامج {{program}}.\n\n[اكتب المعلومات هنا]\n\nرقم المشارك: {{nip}}\nBID Support',
  },
  reminderSubject: { id: 'Lanjutkan belajar di {{program}}', ar: 'واصل التعلم في {{program}}' },
  reminderBody: {
    id: 'Assalamu’alaikum {{nama}},\n\nSilakan lanjutkan materi dan evaluasi di {{program}} melalui portal peserta.\n\nJika ada kendala, hubungi BID Support.\nNIP: {{nip}}',
    ar: 'السلام عليكم {{nama}}،\n\nواصل المواد والتقييم في {{program}} عبر بوابة المشاركين.\n\nللمساعدة اتصل بـ BID Support.\nرقم المشارك: {{nip}}',
  },
  save: { id: 'Simpan draft', ar: 'حفظ المسودة' },
  saveTemplate: { id: 'Simpan template baru', ar: 'حفظ قالب جديد' },
  updateTemplate: { id: 'Perbarui template', ar: 'تحديث القالب' },
  saved: { id: 'Tersimpan. Belum ada email dikirim.', ar: 'تم الحفظ. لم يُرسل بريد بعد.' },
  preview: { id: 'Pratinjau email', ar: 'معاينة البريد' },
  saveFirst: {
    id: 'Simpan perubahan sebelum pratinjau dan penjadwalan.',
    ar: 'احفظ التغييرات قبل المعاينة والجدولة.',
  },
  scheduleHeading: { id: 'Jadwal satu kali', ar: 'جدولة مرة واحدة' },
  schedule: { id: 'Jadwalkan pengiriman', ar: 'جدولة الإرسال' },
  when: { id: 'Tanggal & jam (WIB / UTC+7)', ar: 'التاريخ والوقت (WIB / UTC+7)' },
  confirm: {
    id: 'Pesan ini informasi pembelajaran untuk program terpilih, bukan promosi tanpa persetujuan. Saya sudah memeriksa isi dan penerimanya.',
    ar: 'هذه معلومات تعلم للبرنامج المحدد وليست ترويجًا دون موافقة. راجعت الرسالة والمستلمين.',
  },
  frozen: {
    id: 'Saat dijadwalkan, pesan dan daftar penerima dikunci. Untuk mengubahnya, batalkan dan buat draft baru. Peserta baru setelahnya tidak ditambahkan otomatis.',
    ar: 'تُقفل الرسالة وقائمة المستلمين عند الجدولة. للتغيير ألغِ وأنشئ مسودة جديدة. لا يُضاف مشاركون جدد تلقائيًا.',
  },
  scheduled: {
    id: 'Pengiriman dijadwalkan. Daftar penerima sudah dibekukan.',
    ar: 'تمت الجدولة وتثبيت قائمة المستلمين.',
  },
  progress: { id: 'Progres pemrosesan', ar: 'تقدم المعالجة' },
  of: { id: 'dari', ar: 'من' },
  pause: { id: 'Jeda', ar: 'إيقاف مؤقت' },
  resume: { id: 'Lanjutkan antrean', ar: 'استئناف الانتظار' },
  cancel: { id: 'Batalkan kampanye', ar: 'إلغاء الحملة' },
  cancelConfirm: {
    id: 'Batalkan penerima yang belum dikirim? Email yang sudah diterima provider tidak dapat ditarik.',
    ar: 'إلغاء المستلمين الذين لم يُرسل إليهم؟ لا يمكن استرجاع بريد قبله المزود.',
  },
  inflight: {
    id: 'Jeda/batal menghentikan antrean berikutnya. Permintaan yang sedang berjalan dapat tetap selesai. Hasil tidak pasti tidak dikirim ulang otomatis.',
    ar: 'الإيقاف والإلغاء يوقفان الانتظار التالي؛ قد يكتمل الطلب الجاري. لا تُعاد النتائج غير المؤكدة تلقائيًا.',
  },
  recipients: { id: 'Riwayat penerima', ar: 'سجل المستلمين' },
  today: { id: 'Hari ini (WIB)', ar: 'اليوم (WIB)' },
  allDays: { id: 'Semua tanggal', ar: 'كل التواريخ' },
  day: { id: 'Tanggal percobaan kirim (WIB)', ar: 'تاريخ محاولة الإرسال (WIB)' },
  search: { id: 'Cari nama / email / NIP', ar: 'ابحث بالاسم / البريد / الرقم' },
  status: { id: 'Status', ar: 'الحالة' },
  allStatus: { id: 'Semua status', ar: 'كل الحالات' },
  email: { id: 'Penerima', ar: 'المستلم' },
  time: { id: 'Waktu kirim (WIB)', ar: 'وقت الإرسال (WIB)' },
  reason: { id: 'Keterangan / sumber', ar: 'الوصف / المصدر' },
  noRecipients: { id: 'Tidak ada penerima sesuai filter.', ar: 'لا يوجد مستلمون يطابقون الفلتر.' },
  next: { id: 'Berikutnya', ar: 'التالي' },
  previous: { id: 'Sebelumnya', ar: 'السابق' },
  reconcile: { id: 'Cocokkan log', ar: 'مطابقة السجل' },
  reconcileHeading: { id: 'Rekonsiliasi hasil provider', ar: 'مصالحة نتيجة المزود' },
  reconcileHelp: {
    id: 'Gunakan hanya setelah memeriksa log Mailketing untuk ID pesan ini. Catatan wajib; perubahan dicatat dalam audit.',
    ar: 'فقط بعد فحص سجل Mailketing لهذا المعرف. الملاحظة مطلوبة والتغيير مسجل للتدقيق.',
  },
  verifiedReason: { id: 'Bukti / alasan dari log provider', ar: 'دليل / سبب من سجل المزود' },
  apply: { id: 'Simpan hasil terverifikasi', ar: 'حفظ النتيجة المؤكدة' },
  close: { id: 'Tutup', ar: 'إغلاق' },
  draftStatuses: {
    DRAFT: { id: 'Draft', ar: 'مسودة' },
    SCHEDULED: { id: 'Terjadwal', ar: 'مجدولة' },
    RUNNING: { id: 'Sedang diproses', ar: 'قيد المعالجة' },
    PAUSED: { id: 'Dijeda', ar: 'متوقفة مؤقتًا' },
    COMPLETED: { id: 'Antrean selesai', ar: 'اكتمل الانتظار' },
    CANCELLED: { id: 'Dibatalkan', ar: 'ملغاة' },
  },
  deliveryStatuses: {
    WAITING: { id: 'Menunggu', ar: 'بانتظار' },
    SENDING: { id: 'Sedang dikirim', ar: 'جار الإرسال' },
    ACCEPTED: { id: 'Diterima provider', ar: 'قبله المزود' },
    DELIVERED: { id: 'Terkirim terverifikasi', ar: 'تسليم مؤكد' },
    OPENED: { id: 'Dibuka', ar: 'مفتوح' },
    FAILED: { id: 'Gagal', ar: 'فشل' },
    BLACKLISTED: { id: 'Blacklist', ar: 'محظور' },
    SKIPPED: { id: 'Dilewati', ar: 'متجاوز' },
    UNKNOWN: { id: 'Belum pasti', ar: 'غير مؤكد' },
    CANCELLED: { id: 'Dibatalkan', ar: 'ملغى' },
  },
  registrationStatuses: {
    APPROVED: { id: 'Diterima', ar: 'مقبول' },
    PENDING: { id: 'Menunggu persetujuan', ar: 'بانتظار الموافقة' },
    REJECTED: { id: 'Ditolak', ar: 'مرفوض' },
    REVISION: { id: 'Revisi', ar: 'مراجعة' },
    CANCELLED: { id: 'Dibatalkan', ar: 'ملغى' },
  },
};
